module.exports = __webpack_public_path__ + "img/lens-167-plus-01.ef354de2.png";